export default __webpack_public_path__ + "static/media/arrow_prev_icon.db3b640f.svg";